<template>
  <v-navigation-drawer
    class="navigation-widget"
    color="#f7f7f7"
    v-model="value"
    temporary
    fixed
  >
    <router-link to="/" class="d-flex px-2 py-4">
      <img
        v-if="informations.img"
        :src="files + informations.img"
        :alt="informations.name"
        class="d-block mx-auto navbar-brand"
      />
    </router-link>

    <div class="d-flex justify-center mb-4">
      <template v-for="(item, i) in social">
        <v-btn
          v-if="item"
          :key="i"
          :href="item.link"
          target="blank"
          class="mr-1 d-flex"
          width="40px"
          height="40px"
          icon
        >
          <v-icon color="primary" size="20">
            {{ item.icon }}
          </v-icon>
        </v-btn>
      </template>
    </div>

    <PwaButtonWidget />

    <v-list class="mt-2 px-0" nav>
      <template v-for="{ text, to } in menu">
        <v-list-item
          :key="text"
          class="my-0 nav-link"
          v-bind="getLinkAttrs(to, server)"
          link
        >
          <v-list-item-title
            class="text-body-2 font-weight-medium px-4 primary--text"
          >
            {{ text }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>

    <template v-if="customerArea.tenant_portal || customerArea.landlord_portal">
      <v-sheet color="rgba(0,0,0,.2)" width="100%" height="1px"></v-sheet>

      <div class="my-2 px-4">
        <v-btn
          v-if="customerArea.tenant_portal === customerArea.landlord_portal"
          class="
            white--text
            text-caption text-lg-body-1 text-none text-uppercase
            font-weight-medium
            px-2
            nav-link
          "
          active-class="nav-link-active"
          color="primary"
          :href="customerArea.tenant_portal"
          target="_blank"
          depressed
          block
          tile
        >
          Área do Cliente
        </v-btn>
        <v-menu v-else offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="
                white--text
                text-caption text-lg-body-1 text-none text-uppercase
                font-weight-medium
                px-2
                nav-link
              "
              color="primary"
              active-class="nav-link-active"
              depressed
              block
              tile
            >
              Área do Cliente
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-if="customerArea.tenant_portal"
              :href="customerArea.tenant_portal"
              target="_blank"
            >
              <v-list-item-title class="text-caption font-weight-medium">
                Sou Locatário
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="customerArea.landlord_portal"
              :href="customerArea.landlord_portal"
              target="_blank"
            >
              <v-list-item-title class="text-caption font-weight-medium">
                Sou Proprietário
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>

    <v-sheet color="rgba(0,0,0,.2)" width="100%" height="1px"></v-sheet>

    <v-list class="mt-2 px-0" nav>
      <template v-for="{ text, to } in menuTop">
        <v-list-item
          :key="text"
          class="my-0 nav-link"
          v-bind="getLinkAttrs(to, server)"
          link
        >
          <v-list-item-title
            class="text-body-2 font-weight-medium px-4 primary--text"
          >
            {{ text }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { getLinkAttrs } from "../../utils/getLinkAttrs";
import { getSocial } from "../../utils/getSocial";
import PwaButtonWidget from "./PwaButtonWidget.vue";
import { menuTop, menu } from "../../config";

/**
 * Instancie esse componente na App.vue
 * e use a função window.showNavigationDrawer para mostrar o menu lateral.
 */
export default {
  data() {
    return {
      value: false,
      menuTop,
      menu,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
    customerArea() {
      return this.$rest("customer-area").item;
    },
  },
  methods: {
    show() {
      this.value = !this.value;
    },
    getLinkAttrs,
  },
  created() {
    window.showNavigationDrawer = () => this.show();
  },
  components: { PwaButtonWidget },
};
</script>

<style lang="scss" scoped>
.navigation-widget {
  .navbar-brand {
    width: 90%;
  }
}

.v-navigation-drawer--temporary {
  z-index: 999 !important;
}

.v-navigation-drawer--fixed {
  z-index: 999 !important;
}

.dropdown-menu::v-deep {
  .v-icon {
    font-size: 14px !important;
  }

  .v-list-group__header {
    margin-bottom: 0 !important;
    margin-top: 8px;
  }

  .v-list-group__items {
    background-color: rgba(0, 0, 0, 0.1);
  }
}

.nav-link::v-deep {
  &:before {
    opacity: 0 !important;
  }
}
</style>
